
const VocabMedicSearch = {
    'availability' : ['Disponibilidad','Availability.'],
    'earliest_available' : ['🕐 Próxima disponibilidad: ','🕐 Earliest available: .'],
    'city' : ['Ciudad:', 'City:'],
    'location' : ['Disponibilidad', 'Location'],
    'select_profile' : ['Selecciona un perfil', 'Select a profile'],
    'show_skills' : ['Ver habilidades', 'Show skills'],
    'hide_skills' : ['Ocultar habilidades', 'Hide skills'],
    'no_profiles_found': ["No se encontraron perfiles", "No profiles found",],
    'no_work_numbers': ["Sin numero de contacto", "No contact number",],
   
  }
  export default VocabMedicSearch;
    